import React, { useState, useEffect } from 'react';
import { Pie, Line, Bar, HorizontalBar,} from 'react-chartjs-2';

import { GMMain } from './GraphMasterDynamic.style';

import ReactWordcloud from 'react-wordcloud';

import Chart from "react-google-charts";

const GraphMasterDynamic = (props) => {
  let { data, special } = props;
  
  let checkGraphKind = (type) => {
    let labelArray = [];
    let labelArrayVar2 = [];
    let labelArrayCombined = [];
    let dataArray = [];
    let dataArray2 = [];
    let dataArray3 = [];
    let price_new = null;
    let verde = [];
    let amarillo = [];
    let rojo = [];
    let price_list = [];
    let mapData = null;
    let mapData2 = null;
    let Conteo = null;
    let mapInfo = {};
    let mapInfo2 = {};
    let mapInfo3 = {};
    let mapInfo4 = {};
    let word = {}
    let data = null; 
    let options = null; 
    let limit = 8
    let getMapData = null;
    if(type){
      switch(type.name) {
        case 'SentimientoProm_EdadIngreso':

          type.data.map(element => {
            labelArray.push(element.Edad)
            labelArrayVar2.push(element.Ingreso)
            labelArrayCombined.push(`${element.Edad} / ${element.Ingreso}`)
            dataArray.push(element.Sentiment)
            dataArray2.push(element.Conteo)
            return;
          })
          console.log(labelArray)          
          console.log(labelArrayVar2)
          console.log(dataArray)
          console.log(dataArray2)

          data = {
            labels: [...labelArrayCombined],
            datasets: [{
              fill: false,
              label: 'Sentimiento',
              yAxisID: 'Sentimiento',
              // lineTension: 0.1,
              backgroundColor: '#C72544',
              borderColor: '#C72544',
              // borderCapStyle: 'butt',
              // borderDash: [],
              // borderDashOffset: 1.0,
              data: dataArray,
              hoverBackgroundColor: [
                '#C72544',
                // '#DF668F',
                // '#F4CCDA'
              ]
            },
            {
              fill: false,
              steppedLine: true,
              label: 'Conteo',
              yAxisID: 'Conteo',
              // lineTension: 0.1,
              backgroundColor: '#3DBAB3',
              borderColor: '#3DBAB3',
              // borderCapStyle: 'butt',
              // borderDash: [],
              // borderDashOffset: 1.0,
              data: dataArray2,
              hoverBackgroundColor: [
                // '#3DBAB3',
                // '#DF668F',
                '#3DBAB3'
              ]
            }]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: true,
            legend: {
              display:true,
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 9
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Edad / Ingreso'
                }
              }],
              yAxes: [{
                id: 'Sentimiento',
                type: 'linear',
                position: 'left',
                ticks: {
                  fontSize: 9
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sentimiento promedio'
                }
              },
              {
                id: 'Conteo',
                type: 'linear',
                position: 'right',
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Volumen de comentarios'
                }
              }]
            }
          }
          
          return <Line data={data} options={options}/>
          case 'SentimientoProm_EdadRegion':
            type.data.map(element => {
              labelArray.push(element.Edad)
              labelArrayVar2.push(element.Region)
              labelArrayCombined.push(`${element.Edad} / ${element.Region}`)
              dataArray.push(element.Sentiment)
              dataArray2.push(element.Conteo)
              return;
            })
            console.log(labelArray)          
            console.log(labelArrayVar2)
            console.log(dataArray)
            console.log(dataArray2)
  
            data = {
              labels: [...labelArrayCombined],
              datasets: [{
                fill: false,
                label: 'Sentimiento',
                yAxisID: 'Sentimiento',
                // lineTension: 0.1,
                // backgroundColor: 'rgba(75,192,192)',
                borderColor: '#C72544',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray,
                hoverBackgroundColor: [
                  '#C72544',
                  // '#DF668F',
                  // '#F4CCDA'
                ]
              },
              {
                fill: false,
                steppedLine: true,
                label: 'Conteo',
                yAxisID: 'Conteo',
                // lineTension: 0.1,
                // backgroundColor: 'rgba(75,192,192)',
                borderColor: '#3DBAB3',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray2,
                hoverBackgroundColor: [
                  // '#3DBAB3',
                  // '#DF668F',
                  '#3DBAB3'
                ]
              }]
            }
            options = {
              maintainAspectRatio: false,
              responsive: true,
              borderSkipped: true,
              legend: {
                display:true,
                labels: {
                  fontSize: 10
                }
            },
              scales: {
                xAxes: [{
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Edad / Region'
                  }
                }],
                yAxes: [{
                  id: 'Sentimiento',
                  type: 'linear',
                  position: 'left',
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Sentimiento promedio'
                  }
                },
                {
                  id: 'Conteo',
                  type: 'linear',
                  position: 'right',
                  ticks: {
                    fontSize: 11
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Volumen de comentarios'
                  }
                }]
              }
            }
            
            return <Line data={data} options={options}/>
            case 'SentimientoProm_RegionIngreso':
            type.data.map(element => {
              labelArray.push(element.Region)
              labelArrayVar2.push(element.Ingreso)
              labelArrayCombined.push(`${element.Region} / ${element.Ingreso}`)
              dataArray.push(element.Sentiment)
              dataArray2.push(element.Conteo)
              return;
            })
            console.log(labelArray)          
            console.log(labelArrayVar2)
            console.log(dataArray)
            console.log(dataArray2)
  
            data = {
              labels: [...labelArrayCombined],
              datasets: [{
                fill: false,
                label: 'Sentimiento',
                yAxisID: 'Sentimiento',
                // lineTension: 0.1,
                // backgroundColor: 'rgba(75,192,192)',
                borderColor: '#C72544',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray,
                hoverBackgroundColor: [
                  '#C72544',
                  // '#DF668F',
                  // '#F4CCDA'
                ]
              },
              {
                fill: false,
                steppedLine: true,
                label: 'Conteo',
                yAxisID: 'Conteo',
                // lineTension: 0.1,
                // backgroundColor: 'rgba(75,192,192)',
                borderColor: '#3DBAB3',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray2,
                hoverBackgroundColor: [
                  // '#3DBAB3',
                  // '#DF668F',
                  '#3DBAB3'
                ]
              }]
            }
            options = {
              maintainAspectRatio: false,
              responsive: true,
              borderSkipped: true,
              legend: {
                display:true,
                labels: {
                  fontSize: 10
                }
            },
              scales: {
                xAxes: [{
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Region / Ingreso'
                  }
                }],
                yAxes: [{
                  id: 'Sentimiento',
                  type: 'linear',
                  position: 'left',
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Sentimiento promedio'
                  }
                },
                {
                  id: 'Conteo',
                  type: 'linear',
                  position: 'right',
                  ticks: {
                    fontSize: 11
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Volumen de comentarios'
                  }
                }]
              }
            }
            
            return <Line data={data} options={options}/>
            case 'SentimientoProm_SexoEdad':
            type.data.map(element => {
              labelArray.push(element.Sexo)
              labelArrayVar2.push(element.Edad)
              labelArrayCombined.push(`${element.Sexo} / ${element.Edad}`)
              dataArray.push(element.Sentiment)
              dataArray2.push(element.Conteo)
              return;
            })
            console.log(labelArray)          
            console.log(labelArrayVar2)
            console.log(dataArray)
            console.log(dataArray2)
  
            data = {
              labels: [...labelArrayCombined],
              datasets: [{
                fill: false,
                label: 'Sentimiento',
                yAxisID: 'Sentimiento',
                // lineTension: 0.1,
                // backgroundColor: 'rgba(75,192,192)',
                borderColor: '#C72544',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray,
                hoverBackgroundColor: [
                  '#C72544',
                  // '#DF668F',
                  // '#F4CCDA'
                ]
              },
              {
                fill: false,
                steppedLine: true,
                label: 'Conteo',
                yAxisID: 'Conteo',
                // lineTension: 0.1,
                // backgroundColor: 'rgba(75,192,192)',
                borderColor: '#3DBAB3',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray2,
                hoverBackgroundColor: [
                  // '#3DBAB3',
                  // '#DF668F',
                  '#3DBAB3'
                ]
              }]
            }
            options = {
              maintainAspectRatio: false,
              responsive: true,
              borderSkipped: true,
              legend: {
                display:true,
                labels: {
                  fontSize: 10
                }
            },
              scales: {
                xAxes: [{
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Sexo / Edad'
                  }
                }],
                yAxes: [{
                  id: 'Sentimiento',
                  type: 'linear',
                  position: 'left',
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Sentimiento promedio'
                  }
                },
                {
                  id: 'Conteo',
                  type: 'linear',
                  position: 'right',
                  ticks: {
                    fontSize: 11
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Volumen de comentarios'
                  }
                }]
              }
            }
            
            return <Line data={data} options={options}/>
        case 'SentimientoProm_SexoIngreso':

          type.data.map(element => {
            labelArray.push(element.Sexo)
            labelArrayVar2.push(element.Ingreso)
            labelArrayCombined.push(`${element.Sexo} / ${element.Ingreso}`)
            dataArray.push(element.Sentiment)
            dataArray2.push(element.Conteo)
            return;
          })
          console.log(labelArray)          
          console.log(labelArrayVar2)
          console.log(dataArray)
          console.log(dataArray2)

          data = {
            labels: [...labelArrayCombined],
            datasets: [{
              fill: false,
              label: 'Sentimiento',
              yAxisID: 'Sentimiento',
              // lineTension: 0.1,
              backgroundColor: '#C72544',
              borderColor: '#C72544',
              // borderCapStyle: 'butt',
              // borderDash: [],
              // borderDashOffset: 1.0,
              data: dataArray,
              hoverBackgroundColor: [
                '#C72544',
                // '#DF668F',
                // '#F4CCDA'
              ]
            },
            {
              fill: false,
              steppedLine: true,
              label: 'Conteo',
              yAxisID: 'Conteo',
              // lineTension: 0.1,
              backgroundColor: '#3DBAB3',
              borderColor: '#3DBAB3',
              // borderCapStyle: 'butt',
              // borderDash: [],
              // borderDashOffset: 1.0,
              data: dataArray2,
              hoverBackgroundColor: [
                // '#3DBAB3',
                // '#DF668F',
                '#3DBAB3'
              ]
            }]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: true,
            legend: {
              display:true,
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 9
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sexo / Ingreso'
                }
              }],
              yAxes: [{
                id: 'Sentimiento',
                type: 'linear',
                position: 'left',
                ticks: {
                  fontSize: 9
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sentimiento promedio'
                }
              },
              {
                id: 'Conteo',
                type: 'linear',
                position: 'right',
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Volumen de comentarios'
                }
              }]
            }
          }
          
          return <Line data={data} options={options}/>
          
          case 'SentimientoProm_SexoRegion':
  
            type.data.map(element => {
              labelArray.push(element.Sexo)
              labelArrayVar2.push(element.Region)
              labelArrayCombined.push(`${element.Sexo} / ${element.Region}`)
              dataArray.push(element.Sentiment)
              dataArray2.push(element.Conteo)
              return;
            })
            console.log(labelArray)          
            console.log(labelArrayVar2)
            console.log(dataArray)
            console.log(dataArray2)
  
            data = {
              labels: [...labelArrayCombined],
              datasets: [{
                fill: false,
                label: 'Sentimiento',
                yAxisID: 'Sentimiento',
                // lineTension: 0.1,
                backgroundColor: '#C72544',
                borderColor: '#C72544',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray,
                hoverBackgroundColor: [
                  '#C72544',
                  // '#DF668F',
                  // '#F4CCDA'
                ]
              },
              {
                fill: false,
                steppedLine: true,
                label: 'Conteo',
                yAxisID: 'Conteo',
                // lineTension: 0.1,
                backgroundColor: '#3DBAB3',
                borderColor: '#3DBAB3',
                // borderCapStyle: 'butt',
                // borderDash: [],
                // borderDashOffset: 1.0,
                data: dataArray2,
                hoverBackgroundColor: [
                  // '#3DBAB3',
                  // '#DF668F',
                  '#3DBAB3'
                ]
              }]
            }
            options = {
              maintainAspectRatio: false,
              responsive: true,
              borderSkipped: true,
              legend: {
                display:true,
                labels: {
                  fontSize: 10
                }
            },
              scales: {
                xAxes: [{
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Sexo / Region'
                  }
                }],
                yAxes: [{
                  id: 'Sentimiento',
                  type: 'linear',
                  position: 'left',
                  ticks: {
                    fontSize: 9
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Sentimiento promedio'
                  }
                },
                {
                  id: 'Conteo',
                  type: 'linear',
                  position: 'right',
                  ticks: {
                    fontSize: 11
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Volumen de comentarios'
                  }
                }]
              }
            }
            
            return <Line data={data} options={options}/>
        default:
          break;
        }
    }else {
      return <div>No hay información</div>
    }
    
  }
  
  return (
    <GMMain>
      { checkGraphKind(data) }
    </GMMain>
  );
}

  export default GraphMasterDynamic;